module.exports = __webpack_public_path__ + "f095ea670855eb39033847b55e3a6f37.svg";